import { Link } from "react-router-dom";
import { Question, ArrowRight } from "@phosphor-icons/react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { glossaryTerm } from "@/lib/glossary";

export default function InfoTip({ termId, className = "" }) {
  const entry = glossaryTerm(termId);
  if (!entry) return null;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          data-testid={`infotip-${termId}`}
          onClick={(e) => e.stopPropagation()}
          className={`inline-flex items-center justify-center w-[18px] h-[18px] rounded-full bg-secondary hover:bg-border text-muted2 transition-colors align-middle ${className}`}
          title={`What does "${entry.term}" mean?`}
        >
          <Question size={12} weight="bold" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-72 rounded-2xl p-4" data-testid={`infotip-content-${termId}`}>
        <div className="text-sm font-semibold">{entry.term}</div>
        <p className="text-sm text-muted2 mt-1.5 leading-relaxed">{entry.long}</p>
        <Link
          to="/glossary"
          data-testid={`infotip-glossary-link-${termId}`}
          className="inline-flex items-center gap-1 text-xs font-medium text-brand mt-3 hover:gap-2 transition-all"
        >
          Full glossary <ArrowRight size={12} weight="bold" />
        </Link>
      </PopoverContent>
    </Popover>
  );
}
